import * as Types from '@common/oneclub/types'

/** 国家/区域名称 */
export type CountryName = 'SG' | 'MY' | 'TH' | 'VN' | 'US' | 'ID' | 'CN' | 'TW'

/** 国家/区域名称 */
export type CountryCode = 'SG' | 'MY' | 'TH' | 'VN' | 'US' | 'ID' | 'CN' | 'TW'

/** 国家/区域名称 */
export const COUNTRY_NAME: Types.DictLabel<CountryName> = {
  SG: 'Singapore',
  MY: 'Malaysia',
  TH: 'Thailand',
  VN: 'Vietnam',
  US: 'UniteState',
  ID: 'Indonesia',
  CN: 'China',
  TW: 'Taiwan',
}

/** 钱包账户对应地区的多语言的key*/
export const WALLET_COUNTRY_NAME = {
  SG: 'wallet.accountSG',
  MY: 'wallet.accountMY',
  TH: 'wallet.accountTH',
  VN: 'wallet.accountVN',
  HK: 'wallet.accountHK',
  CN: 'wallet.accountCN',
  TW: 'wallet.accountTW',
}

export const COUNTRY_CODE = ['SG', 'MY', 'TH', 'VN']
